<template>
  <div class="container">
    <div v-wechat-title="title"></div>
    <div style="background-color: #fff; position: relative; z-index: 35">
      <div v-if="tId < 13" class="tab-box">
        <div
          @click.stop="typeClick(1)"
          class="tb_item"
          :class="tId == 1 ? 'act' : ''"
        >
          <div><span class="iconfont icon-cpj"></span></div>
          <span>产品奖</span>
        </div>
        <div
          @click.stop="typeClick(4)"
          class="tb_item"
          :class="tId == 4 ? 'act' : ''"
        >
          <div><span class="iconfont icon-jsj"></span></div>
          <span>设计奖</span>
        </div>
        <div
          @click.stop="typeClick(3)"
          class="tb_item"
          :class="tId == 3 ? 'act' : ''"
        >
          <div><span class="iconfont icon-gcj"></span></div>
          <span>工程奖</span>
        </div>  
        <div
          @click.stop="typeClick(11)"
          class="tb_item"
          :class="tId == 11 ? 'act' : ''"
        >
          <div><span class="iconfont icon-xinpian"></span></div>
          <span>数智成果奖</span>
        </div>
        <div
          @click.stop="typeClick(12)"
          class="tb_item"
          :class="tId == 12 ? 'act' : ''"
        >
          <div><span class="iconfont icon-fenxi"></span></div>
          <span>数智设计奖</span>
        </div>        
      </div>
      <van-search
        v-model="keyword"
        placeholder="搜索项目关键词"
        @search="onSearch"
        @clear="onSearch"
      ></van-search>

      <van-sticky offset-top="0" z-index="10">
        <div class="type-box">
          <div
            class="tpb_div"
            @click.stop="businessClick"
            v-if="tId == 6 || tId == 7"
          >
            <div class="overFlowOne">
              {{ tId == 6 ? "智能照明生态百强榜" : "照明细分领域出口企业50强" }}
            </div>
            <span
              class="iconfont"
              :class="businessShow ? 'icon-shangla' : 'icon-xiala'"
            ></span>
            <div class="tpbv_area" v-if="businessShow">
              <div :class="tId == 6 ? 'act' : ''" @click.stop="typeClick(6)">
                智能照明生态百强榜
              </div>
              <div :class="tId == 7 ? 'act' : ''" @click.stop="typeClick(7)">
                照明细分领域出口企业50强
              </div>
            </div>
          </div>
          <div class="tpb_div" @click.stop="classifyClick">
            <div class="overFlowOne">{{ cText }}</div>
            <span
              class="iconfont"
              :class="classifyShow ? 'icon-shangla' : 'icon-xiala'"
            ></span>
            <div class="tpbv_scroll" v-if="classifyShow">
              <div class="tpbvs_list">
                <div
                  v-for="(item, index) in classifyList"
                  :key="index"
                  :class="cId == item.AwardCategoryID ? 'act' : ''"
                  :data-name="item.CategoryNameChi"
                  @click.stop="
                    typeClick(tId, rId, item.AwardCategoryID, $event)
                  "
                >
                  {{ item.CategoryNameChi }}
                </div>
              </div>
            </div>
          </div>
          <div class="tpb_div" @click.stop="reportClick">
            <div class="overFlowOne">
              {{ rId == 2 ? "优秀奖" : rId == 3 ? "最佳奖" : "全部申报" }}
            </div>
            <span
              class="iconfont"
              :class="reportShow ? 'icon-shangla' : 'icon-xiala'"
            ></span>
            <div class="tpbv_area" v-if="reportShow">
              <div
                :class="rId == 1 ? 'act' : ''"
                @click.stop="typeClick(tId, 1, cId)"
              >
                全部申报
              </div>
              <!-- 企业没有优秀奖 -->
              <div
                :class="rId == 2 ? 'act' : ''"
                @click.stop="typeClick(tId, 2, cId)"
                v-if="tId != 6 && tId != 7"
              >
                优秀奖
              </div>
              <div
                :class="rId == 3 ? 'act' : ''"
                @click.stop="typeClick(tId, 3, cId)"
              >
                最佳奖
              </div>
            </div>
          </div>
        </div>
      </van-sticky>
    </div>

    <van-list
      v-model="loading"
      :finished="finished"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="getList"
    >
      <div
        v-for="(item, index) in list"
        :key="index"
        class="proItem"
        :class="tId == 6 || tId == 7 ? 'afit' : ''"
        @click.stop="proItemClick(item.Id, item.AwardType)"
      >
        <div class="tuijian" v-if="item.IsJuryRecommend">
          <span class="iconfont icon-zan-fill"></span>评委推荐
        </div>
        <div class="pi_img">
          <van-image
            :src="item.Thumbnail"
            :fit="tId == 6 || tId == 7 ? 'contain' : 'cover'"
          ></van-image>
        </div>
        <div class="pi_right">
          <div class="overFlowTwo">{{ item.Title }}</div>
          <span>{{ item.CategoryNameChi }}</span>
        </div>
      </div>
    </van-list>

    <div class="noDataBox" v-if="list.length == 0">
      <div class="kongIcon"><span class="iconfont icon-kong"></span></div>
      <div>什么也没有！</div>
    </div>

    <div class="right-box">
      <div @click="toPathHandle">
        <img src="../../../static/images/lighting/declare.png" />
      </div>
    </div>
    <!-- 遮罩层 -->
    <div
      class="mask-layer"
      v-if="businessShow || classifyShow || reportShow"
      @click.stop="maskLayerClose"
    ></div>
  </div>
</template>
<script>
import sdjproject from "@/utils/sdjproject";
import { List, Sticky, Image, Search } from "vant";
import { awardCateList, awardList } from "@/api/lighting";
export default {
  name: "project",
  components: {
    "van-sticky": Sticky,
    "van-list": List,
    "van-image": Image,
    "van-search": Search,
  },
  data() {
    return {
      title: "",
      awardYear: Number(this.awardYear),
      tId: 1, //产品1 技术奖2 工程3 设计4 雅江5 百强企业6（x） 照明细分领域出口企业50强7  智能成果奖8  智能工程设计奖9  智能系统集成商奖10

      keyword: "",
      businessShow: false, //企业下拉显示
      classifyShow: false, //分类下拉显示
      cText: "全部类别",
      cId: 0,
      classifyList: [],
      reportShow: false, //申报下拉显示
      rId: 1, //1全部申报 2优秀奖 3最佳奖

      list: [],
      loading: false,
      finished: false,
      total: 0,
      pageIndex: 1,
      error: false,
    };
  },

  methods: {
    //关闭弹窗
    maskLayerClose() {
      this.businessShow = false;
      this.classifyShow = false;
      this.reportShow = false;
    },

    //奖项类型
    typeClick(n, rId, cId, event) {
      if (!cId) {
        this.cText = "全部类型";
      } else if (cId != this.cId) {
        this.cText = event.target.dataset.name;
      }
      this.tId = n;
      this.cId = cId;
      this.rId = rId;
      this.businessShow = false;
      this.classifyShow = false;
      this.reportShow = false;
      this.getAwardCateList();
      this.pageIndex = 1;
      this.getList();
      this.$router.replace({
        path: "/project",
        query: { id: this.tId, rid: this.rId, cid: this.cId },
      });
    },

    //企业版下拉
    businessClick() {
      this.businessShow = !this.businessShow;
      this.classifyShow = false;
      this.reportShow = false;
    },

    //分类下拉
    classifyClick() {
      this.businessShow = false;
      this.classifyShow = !this.classifyShow;
      this.reportShow = false;
    },

    //申报下拉
    reportClick() {
      this.businessShow = false;
      this.classifyShow = false;
      this.reportShow = !this.reportShow;
    },

    //获取类型
    getAwardCateList() {
      var that = this;
      var data = {
        AwardYear: that.awardYear,
        AwardTypeValue: that.tId,
      };
      awardCateList(data).then((res) => {
        if (that.cId > 0) {
          res.Data.List.forEach((item, index) => {
            if (that.cId == item.AwardCategoryID) {
              that.cText = item.CategoryNameChi;
            }
          });
        }
        var list = [
          {
            AwardCategoryID: 0,
            CategoryNameChi: "全部类别",
          },
        ];
        that.classifyList = list.concat(res.Data.List);
      });
    },

    //搜索
    onSearch() {
      this.pageIndex = 1;
      this.getList();
    },

    //获取列表
    getList() {
      var that = this;
      var data = {
        Page: {
          PageSize: 20,
          PageIndex: that.pageIndex,
        },
        AwardYear: that.awardYear,
        AwardTypeValue: that.tId,
        ListTypeValue: that.rId,
        AwardCategoryId: that.cId,
        KeyWord: that.keyword,
      };
      awardList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch(() => {
          that.error = true;
        });
    },

    //我要申报
    toPathHandle() {
      if (this.tId < 8) {
        window.location.href =
          "https://www.alighting.cn/webapp/award/declare.htm?t=1";
      } else {
        window.location.href =
          "https://www.alighting.cn/webapp/award/declarei.htm";
      }
    },

    //作品详情
    proItemClick(id, type) {
      this.$router.push({
        path: "/projectDetail",
        query: {
          id: id,
          awardType: type,
        },
      });
    },
  },

  mounted() {
    this.tId = this.$route.query.id ? this.$route.query.id : 1;
    this.rId = this.$route.query.rid;
    this.cId = this.$route.query.cid;
    if (this.Common._isMobile()) {
      this.title = this.tId < 8 ? "照明板块申报列表" : "智能生态奖申报列表";
      this.getAwardCateList();
    } else {
      window.location.href = `https://sdj.alighting.com/${sdjproject.getType(
        this.tId
      )}.html?awardCategoryId=${
        this.cId ? this.cId : 0
      }&awardYear=2026&fieldid=${
        this.tId > 7 ? "2" : "1"
      }&listType=${sdjproject.getListType(this.rId)}`;
    }
  },
};
</script>
<style scoped src="../../../static/css/project.css">
</style>